<template>
  <div class="stream">
    <ViewHeaderBar>
      <template #left></template>
      <template #right>
        <Button class="header-item btn" type="primary" @click="goToCreateStreamPage">
          {{ $t('streams.createStream') }}
        </Button>
      </template>
    </ViewHeaderBar>

    <Table :loading="loading" :columns="recordsCol" :data="records"></Table>
  </div>
</template>

<script lang="jsx">
import nodeID from '@/mixins/nodeID'
import ViewHeaderBar from '@/components/ViewHeaderBar.vue'

import { loadStreams, deleteStream } from '@/api/stream'

export default {
  name: 'Stream',

  mixins: [nodeID],
  components: {
    ViewHeaderBar,
  },

  data() {
    return {
      loading: false,
      records: [],
      recordsCol: [
        {
          title: this.$t('common.name'),
          key: 'name',
          render: (h, params) => {
            return (
              <div>
                <a
                  href="javascript:;"
                  onClick={() => {
                    this.showDetail(params.row, 'view')
                  }}
                >
                  {params.row.name}
                </a>
              </div>
            )
          },
        },
        {
          title: this.$t('common.operations'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return (
              <div>
                <a
                  style="margin-right: 10px;"
                  href="javascript:;"
                  onClick={() => {
                    this.showDetail(params.row, 'edit')
                  }}
                >
                  <Icon type="ios-create"></Icon>
                </a>
                <a href="javascript:;">
                  <Poptip
                    confirm={true}
                    transfer={true}
                    width={200}
                    title={this.$t('streams.deleteStreamWarning')}
                    placement="top"
                    type="error"
                    vOn:on-ok={() => {
                      this.remove(params.row)
                    }}
                    vOn:on-cancel={() => {}}
                  >
                    <Icon type="md-trash"></Icon>
                  </Poptip>
                </a>
              </div>
            )
          },
        },
      ],
    }
  },

  created() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.loading = true
      loadStreams(this.nodeID)
        .then((res) => {
          this.records = res.data.map((item) => ({ name: item }))
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    goToCreateStreamPage() {
      this.$router.push({
        name: 'streamDetails',
        params: {
          streamName: 0,
        },
        query: {
          oper: 'create',
        },
      })
    },
    showDetail({ name }, oper) {
      this.$router.push({
        path: `/nodes/${this.nodeID}/source/stream/${name}`,
        query: { oper },
      })
    },
    remove({ name }) {
      deleteStream(this.nodeID, name)
        .then((res) => {
          if (res.status === 200 && res.statusText === 'OK') {
            this.$Message.success(res.data)
          } else {
            this.$Message.success(this.$t('common.deleteSuccess'))
          }
          this.loadData()
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss"></style>
